import { ROUTE_PATH } from '../../utils/constants'

export const footerLinkColumns = [
  [ROUTE_PATH.aboutUs, ROUTE_PATH.whatWeDo, ROUTE_PATH.vacancies, ROUTE_PATH.events, ROUTE_PATH.news],
  [ROUTE_PATH.contacts, ROUTE_PATH.faq, ROUTE_PATH.privacyPolicy],
]
